export const NAV_LINKS = [
    { label: "Beranda", id: "home" },
    { label: "Tentang Kami", id: "about" },
    { label: "Perusahaan Kami", id: "companies" },
    { label: "Platform", id: "platforms" },
    { label: "Peta Jalan Strategis", id: "roadmap" },
    { label: "Proyek / Kapabilitas", id: "projects" },
    { label: "Hubungan Investor", id: "investors" },
    { label: "Kontak", id: "contact" },
];

export const SECTORS = [
    {
        num: "01",
        title: "ENERGI",
        desc: "Pembangkitan listrik, energi terbarukan, sistem hibrida, dan aset energi strategis.",
        icon: "Zap",
    },
    {
        num: "02",
        title: "TRANSMISI",
        desc: "Transmisi tegangan tinggi, gardu induk, perluasan grid, dan komisioning.",
        icon: "Cable",
    },
    {
        num: "03",
        title: "INFRASTRUKTUR",
        desc: "Konstruksi, pengembangan properti, dan infrastruktur strategis.",
        icon: "Building2",
    },
];

export const WHY_SADJA = [
    {
        num: "01",
        title: "PASAR BERTUMBUH TINGGI",
        desc: "Beroperasi di salah satu wilayah infrastruktur dengan pertumbuhan tercepat.",
        icon: "TrendingUp",
    },
    {
        num: "02",
        title: "JARINGAN INDUSTRI BERPENGALAMAN",
        desc: "Dibangun di atas pengalaman industri kolektif puluhan tahun dalam proyek transmisi dan energi.",
        icon: "Network",
    },
    {
        num: "03",
        title: "VISI JANGKA PANJANG",
        desc: "Berfokus pada penciptaan nilai perusahaan yang berkelanjutan, bukan keuntungan proyek jangka pendek.",
        icon: "Landmark",
    },
    {
        num: "04",
        title: "FOKUS STRATEGIS",
        desc: "Berfokus pada sektor energi dan infrastruktur dengan hambatan masuk yang tinggi.",
        icon: "Crosshair",
    },
    {
        num: "05",
        title: "MODEL BISNIS YANG SKALABEL",
        desc: "Evolusi dari kontraktor menjadi platform EPC hingga pemilik aset infrastruktur.",
        icon: "Layers",
    },
];

export const ROADMAP = [
    {
        year: "2026",
        title: "FONDASI",
        note: "Membangun kredibilitas operasional dan mengamankan proyek unggulan.",
        bullets: [
            "Membangun kredibilitas operasional",
            "Mengeksekusi proyek transmisi dan gardu induk besar pertama",
            "Membangun kapabilitas pendukung EPC",
            "Membangun kapabilitas platform PLTMG",
            "Membangun platform komisioning dan O&M",
            "Implementasi tata kelola perusahaan",
            "Kerangka kesiapan investor",
        ],
    },
    {
        year: "2027",
        title: "EKSPANSI",
        note: "Meningkatkan kapasitas eksekusi proyek.",
        bullets: [
            "Berbagai proyek GI",
            "Infrastruktur data center",
            "Paket SUTT/SUTET",
            "Partisipasi EPC PLTMG",
            "Proyek EPC surya",
            "Sistem kelistrikan industri",
            "Kemitraan regional",
        ],
    },
    {
        year: "2028",
        title: "PENSKALAAN",
        note: "Transisi dari kontraktor menuju platform infrastruktur.",
        bullets: [
            "Memulai kepemilikan minoritas pada aset energi",
            "Membentuk struktur SPV",
            "Mengembangkan aliran pendapatan berulang",
            "Transisi dari kontraktor menuju platform infrastruktur",
        ],
    },
    {
        year: "2029",
        title: "PLATFORM REGIONAL",
        note: "Berekspansi ke luar Indonesia.",
        markets: ["Malaysia", "Filipina", "Vietnam"],
        bullets: [
            "Kemitraan EPC regional",
            "Akuisisi aset",
            "Investasi infrastruktur",
        ],
    },
    {
        year: "2030",
        title: "GRUP INFRASTRUKTUR",
        note: "Menjadi platform infrastruktur terintegrasi terkemuka.",
        bullets: ["Menjadi platform infrastruktur terintegrasi terkemuka."],
    },
];

export const ASSET_STAGES = [
    {
        num: "1",
        period: "2026–2027",
        title: "MODEL ASET RINGAN",
        groups: [
            {
                label: "Fokus",
                items: ["EPC", "Komisioning", "Layanan O&M"],
            },
        ],
        highlight: "Fokus Strategis: Eksekusi & Kas",
    },
    {
        num: "2",
        period: "2028–2030",
        title: "MODEL ASET HIBRIDA",
        groups: [
            {
                label: "Aset Energi",
                items: ["PLTS", "Captive Plant", "Sistem Hibrida"],
            },
            {
                label: "Aset Utilitas",
                items: ["Infrastruktur Energi", "Utilitas Industri"],
            },
        ],
        highlight: "Target Basis Aset: Rp 1–2 Triliun",
    },
    {
        num: "3",
        period: "2031–2035",
        title: "PLATFORM KEPEMILIKAN ASET",
        groups: [
            {
                label: "Target IPP",
                items: ["PLTMG", "Surya", "Pembangkit Hibrida"],
            },
            {
                label: "Infrastruktur Utilitas",
                items: ["Sistem Energi Industri", "Kelistrikan Data Center"],
            },
        ],
        highlight: "Target Nilai Aset: Rp 10–20 Triliun",
    },
];

export const LEADERSHIP = [
    {
        name: "Bito Leilia Atmadja",
        role: "Pendiri & Direktur Utama",
        areas: [
            "Strategi Korporasi",
            "Arah Investasi",
            "Pengembangan Bisnis",
            "Kemitraan Strategis",
        ],
        vision: "“Membangun platform infrastruktur dan energi kelas dunia yang berasal dari Asia Tenggara.”",
    },
    {
        name: "Bima Eka Sakti",
        role: "Komisaris Utama",
        areas: [
            "Tata Kelola Perusahaan",
            "Hubungan Pemerintahan",
            "Pengawasan Strategis",
        ],
    },
    {
        name: "Segera Diangkat",
        role: "Direktur Keuangan",
        areas: [
            "Manajemen Permodalan",
            "Perencanaan Keuangan",
            "Hubungan Investor",
            "Penghimpunan Dana",
        ],
        vacant: true,
    },
];

export const INVESTOR_CARDS = [
    {
        num: "01",
        title: "MITRA STRATEGIS",
        desc: "Kemitraan infrastruktur dan energi",
        icon: "Handshake",
    },
    {
        num: "02",
        title: "MITRA MODAL",
        desc: "Investasi infrastruktur jangka panjang",
        icon: "LineChart",
    },
    {
        num: "03",
        title: "MITRA PROYEK",
        desc: "EPC, utilitas, pengembang, dan pemangku kepentingan strategis",
        icon: "Users",
    },
];
